export default __webpack_public_path__ + "static/media/T_LightBlue.0acf5d37.png";